const initialSearchDataState = {
  data : false
}

export const SearchDataReducer = (state = initialSearchDataState, action = {}) => {    
  
    switch (action.type) {            
        case 'SEARCHDATA':       
            return {
              ...state,
              data: action.dataForSearch            

            }
     
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/SearchDataReducer.js